import Axios from 'axios'
import { Dispatch } from 'redux'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'
import { ActionResponse } from 'util/types/index'
import { PartnerDeliveryConfig, PartnerDeliveryConfigData, PartnerDeliveryConfigTypes } from './types'

export function createPartnerDeliveryConfig (partnerId: number|string, data: PartnerDeliveryConfigData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerDeliveryConfig>> => {
    return Axios
      .post(`/partner/${partnerId}/delivery-config`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao cadastrar a configuração de entrega')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function updatePartnerDeliveryConfig (partnerId: number, id: number, data: PartnerDeliveryConfigData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerDeliveryConfig>> => {
    return Axios
      .put(`/partner/${partnerId}/delivery-config/${id}`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_UPDATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar a configuração de entrega')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deletePartnerDeliveryConfig (partnerId: number|string, id: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerDeliveryConfig>> => {
    return Axios
      .delete(`/partner/${partnerId}/delivery-config/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar a configuração de entrega')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getPartnerDeliveryConfigs (partnerId: number|string) {
  return async (dispatch: Dispatch): Promise<ActionResponse<PartnerDeliveryConfig>> => {
    return Axios
      .get(`/partner/${partnerId}/delivery-config`)
      .then(res => res.data)
      .then(res => {
        dispatch({ type: PartnerDeliveryConfigTypes.PARTNER_DELIVERY_CONFIG_GET_LIST, payload: res.data })
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover a configuração de entrega')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}
